const config = {
  appSync: {
    endpoint:
      "https://cukh7vbugnf3jigzdghrf3nhim.appsync-api.us-east-1.amazonaws.com/graphql"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_FqEvZgyZw",
    APP_CLIENT_ID: "74jjbko5u0ebsjurrli5hrnpmu"
  },
  auth: {
    LOGIN_URL:
      "https://meads.auth.us-east-1.amazoncognito.com/login?client_id=1dke8f1h4ru2r534imtkj0sjh4&response_type=token&scope=phone+email+openid+aws.cognito.signin.user.admin+profile&redirect_uri=https://meads.margagl.io/"
  }
};

switch (window.location.hostname) {
  case "hll2v.csb.app":
    config.auth.LOGIN_URL =
      "https://meads.auth.us-east-1.amazoncognito.com/login?client_id=74jjbko5u0ebsjurrli5hrnpmu&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://hll2v.csb.app/";
    break;
  default:
    break;
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js